class Paging{
    //transfer:进行分页拼接的数据处理函数
    constructor({api,pageSize=10,params={},transfer}){
        this.page = {
            pageNum:0,
            pageSize:pageSize,
            totalPage:1
        }
        this.api = api;
        this.defaultParams = params;
        this.data = [];     //列表应展示的数据(拼接).

        this.isEnd = false;
        this.transfer = transfer;
        this.isBlock = false;   //是否正在请求

        this.pro = null;
        this.cancel
    }

    async next(){
        if (!this.isEnd){            
            if (this.isBlock){
                // return this.pro;
                return Promise.reject('正在请求中');
            }
            this.isBlock = true;

            let params = Object.assign({
                page:{
                    pageNum:this.page.pageNum + 1,
                    pageSize:this.page.pageSize
                }
            },this.defaultParams);

            let proCancel;
            this.pro = this.api(params).then(res=>{
                if (proCancel().cancel){
                    return Promise.reject('取消请求');
                }
                if (res.code == 200){
                    // 数据处理
                    if (res.page.pageNum === 1) {                        
                        this.data = [];
                    }
                    let pageData = res.data || [];
                    if (this.transfer){
                        pageData = this.transfer(res)
                    }
                    this.data.push(...pageData);

                    Object.assign(this.page,res.page);
                    this.isEnd = this.page.pageNum >= this.page.totalPage;
                    return [this.data,res];
                } else {
                    console.error('分页请求出错');
                    return Promise.reject(res)
                }
            }).finally(()=>{
                this.isBlock = false;
            });

            proCancel = ($=>()=>$)(this.pro);

            return this.pro;
        } else {
            return Promise.reject('没有更多分页了');
        }
    }
    
    async refresh(){
        this.page.pageNum = 0;
        this.isEnd = false;
        //取消上一个请求.
        if (this.pro){
            this.isBlock = false;
            this.pro.cancel = true;
        }
        return this.next();
    }
}


function createPaging(obj){
    return ()=>new Paging(obj);
}


export default createPaging;